import classNames from 'classnames';
import type { CSSProperties, FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import type { LineupStyle } from '#src/components/lobby/ContenderLayout/types.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { unitMapping } from '#src/lib/style.ts';

const Root = styled.div`
  width: 100%;
  margin: auto;
  display: grid;
  justify-content: center;
  gap: var(--gap);
  grid-template-columns: repeat(20, 1fr);
  grid-template-rows: repeat(24, 1fr);
  grid-template-areas:
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . F F F F F F . . E E E E E E . . .'
    '. . . . . . . . . . . . . . . . . . . .'
    'D D D D D D . . . . . . . . M M M M M M'
    'D D D D D D . . . . . . . . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    'D D D D D D . G G G G G G . M M M M M M'
    '. . . . . . . G G G G G G . . . . . . .'
    '. . . . . . . G G G G G G . . . . . . .';

  &.slots6 {
    grid-template-rows: repeat(24, 1fr);
    grid-template-areas:
      '. . . . . . . V V V V V V . . . . . . .'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . V V V V V V . E E E E E E'
      'F F F F F F . . . . . . . . E E E E E E'
      '. . . . . . . . . . . . . . . . . . . .'
      '. . . . . . . . . . . . . . . . . . . .'
      'D D D D D D . . . . . . . . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      'D D D D D D . G G G G G G . M M M M M M'
      '. . . . . . . G G G G G G . . . . . . .';
  }

  &.slots7 {
    grid-template-rows: repeat(20, 1fr);
    grid-template-columns: repeat(16, 1fr);
    grid-template-areas:
      '. V V V V . . . . . . U U U U .'
      '. V V V V . . . . . . U U U U .'
      '. V V V V . . . . . . U U U U .'
      '. V V V V . E E E E . U U U U .'
      '. V V V V . E E E E . U U U U .'
      '. V V V V . E E E E . U U U U .'
      '. V V V V . E E E E . U U U U .'
      '. V V V V . E E E E . U U U U .'
      'F F F F . . E E E E . . M M M M'
      'F F F F . . E E E E . . M M M M'
      'F F F F . . E E E E . . M M M M'
      'F F F F . . . . . . . . M M M M'
      'F F F F G G G G D D D D M M M M'
      'F F F F G G G G D D D D M M M M'
      'F F F F G G G G D D D D M M M M'
      'F F F F G G G G D D D D M M M M'
      '. . . . G G G G D D D D . . . .'
      '. . . . G G G G D D D D . . . .'
      '. . . . G G G G D D D D . . . .'
      '. . . . G G G G D D D D . . . .';

    &.FOOTBALL {
      grid-template-rows: repeat(20, 1fr);
      grid-template-columns: repeat(16, 1fr);
      grid-template-areas:
        '. . . . V V V V U U U U . . . .'
        '. . . . V V V V U U U U . . . .'
        'F F F F V V V V U U U U E E E E'
        'F F F F V V V V U U U U E E E E'
        'F F F F V V V V U U U U E E E E'
        'F F F F V V V V U U U U E E E E'
        'F F F F V V V V U U U U E E E E'
        'F F F F V V V V U U U U E E E E'
        'F F F F . . . . . . . . E E E E'
        'F F F F . . . . . . . . E E E E'
        '. D D D D . . . . . . M M M M .'
        '. D D D D . . . . . . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. D D D D . G G G G . M M M M .'
        '. . . . . . G G G G . . . . . .'
        '. . . . . . G G G G . . . . . .';
    }
  }

  &.inline {
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-template-areas: 'G D M F E';

    &.slots7 {
      grid-template-columns: repeat(16, 1fr);
      grid-template-rows: repeat(16, 1fr);

      grid-template-areas:
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M';

      &.FOOTBALL {
        grid-template-areas:
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          'F F F F V V V V U U U U E E E E'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .'
          '. . D D D D G G G G M M M M . .';
      }
    }
  }
  /** Used where there is a different number of slots can coexist in the same layout (i.e so5 and so7 on football) */
  &.forced_inline {
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-template-areas: 'G D M F E';

    &.slots7 {
      grid-template-columns: repeat(16, 1fr);
      grid-template-rows: repeat(16, 1fr);

      grid-template-areas:
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        '. . V V V V E E E E U U U U . .'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M'
        'F F F F G G G G D D D D M M M M';

      &.FOOTBALL {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        > * {
          min-width: calc(100% / 5 - var(--gap) / 5 * 9);
        }
      }
    }
  }

  & > * {
    &:nth-child(1) {
      grid-area: G;
    }
    &:nth-child(2) {
      grid-area: D;
    }
    &:nth-child(3) {
      grid-area: M;
    }
    &:nth-child(4) {
      grid-area: F;
    }
    &:nth-child(5) {
      grid-area: E;
    }
    &:nth-child(6) {
      grid-area: V;
    }
    &:nth-child(7) {
      grid-area: U;
    }
  }

  &.smartWidth {
    --card-footer-height: 48px;
    --usable-height: calc(
      var(--total-height, var(--100vh)) * var(--height-percentage)
    );
    --card-height: calc(
      ((11 / 24) * var(--usable-height) - var(--card-footer-height))
    );
    --calc-card-width: calc(var(--card-height) * var(--card-aspect-ratio));
    --width: calc(
      3 * var(--calc-card-width) + (2 / 6) * var(--calc-card-width)
    );
    max-width: clamp(200px, var(--width), 100%);
  }

  &.cancelled {
    filter: grayscale(1);
  }
`;

type Props = {
  className?: string;
  fillHeightPercent?: number;
  slots?: number;
  children?: ReactNode;
  gap?: keyof typeof unitMapping;
  lineupStyle?: LineupStyle;
  cancelled?: boolean;
};

export const LineupCardsLayout: FC<PropsWithChildren<Props>> = ({
  className,
  fillHeightPercent,
  slots = 5,
  children,
  gap = 1,
  lineupStyle = 'spread',
  cancelled,
}) => {
  const { sport } = useSportContext();

  return (
    <Root
      className={classNames(className, sport, lineupStyle, `slots${slots}`, {
        smartWidth: !!fillHeightPercent,
        cancelled,
      })}
      style={
        {
          '--height-percentage': fillHeightPercent,
          '--gap': unitMapping[gap],
        } as CSSProperties
      }
    >
      {children}
    </Root>
  );
};
